<template>
  <v-data-table :headers="headers" item-key="id" :items="bills">
    <template v-slot:item.received_date="{ item }">
      <span v-if="item.received_date">{{ item.received_date }}</span>
      <v-chip v-else-if="item.bill_date" color="error">outstanding</v-chip>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon small class="mr-2" title="Edit bill" @click="$emit('edit', item)">fas fa-file-edit</v-icon>
      <v-icon small title="Has comments" v-if="item.comments">fa-comments</v-icon>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'BillListTable',
  props: ['bills'],
  data: () => ({
    headers: [
      { text: 'Type', value: 'type', sortable: false },
      { text: 'Company to Bill', value: 'registered_company_to_bill', sortable: false },
      { text: 'Fee', value: 'fee', sortable: false },
      { text: 'Fee Type', value: 'type_of_fee', sortable: false },
      { text: 'Bill Date', value: 'bill_date' },
      { text: 'Received Date', value: 'received_date' },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Actions', value: 'action', sortable: false }
    ]
  })
};
</script>
